var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconCommentThin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 30C42.5 31.0609 42.0786 32.0783 41.3284 32.8284C40.5783 33.5786 39.5609 34 38.5 34H14.5L6.5 42V10C6.5 8.93913 6.92143 7.92172 7.67157 7.17157C8.42172 6.42143 9.43913 6 10.5 6H38.5C39.5609 6 40.5783 6.42143 41.3284 7.17157C42.0786 7.92172 42.5 8.93913 42.5 10V30Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCommentThin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconCommentThin.f7808877.svg";
export { ForwardRef as ReactComponent };